import { FaLinkedin, FaTelegram, FaInstagram, FaWhatsapp, FaXTwitter, FaFacebook } from 'react-icons/fa6';
import { TELEGRAM_CHANNEL_URL } from '../../config/social';
import './SocialLinks.css';

function SocialLinks({ className = "" }) {
  const socialLinks = [
    { 
      name: 'Facebook',
      url: 'https://www.facebook.com/people/Jobs-Opportuniti/pfbid0vDPT2QsHfzUS26Q94JgptsuioacViMEiDH3JKFBVgiv27SxnjSsthk7r63EZNXw9l/',
      icon: <FaFacebook className="social-icon-svg" />
    },
    { 
      name: 'Instagram', 
      url: 'https://www.instagram.com/jobsopportunity.in/?igsh=NDI4N2p3ZW1yM24%3D#', 
      icon: <FaInstagram className="social-icon-svg" /> 
    },
    { 
      name: 'X (Twitter)', 
      url: 'https://x.com/Jobsopport61352?t=B5pSngdXa5VdKvp7HvXDtQ&s=08', 
      icon: <FaXTwitter className="social-icon-svg" /> 
    },
    { 
      name: 'Telegram', 
      url: TELEGRAM_CHANNEL_URL, 
      icon: <FaTelegram className="social-icon-svg" /> 
    },
    { 
      name: 'WhatsApp', 
      url: 'https://wa.me/919380867233', 
      icon: <FaWhatsapp className="social-icon-svg" /> 
    }
  ];

  return (
    <div className={`social-links ${className}`}>
      <h3>Connect With Us</h3>
      <div className="social-icons">
        {socialLinks.map(link => (
          <a 
            key={link.name}
            href={link.url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="social-icon"
          >
            {link.icon}
            <span>{link.name}</span>
          </a>
        ))}
      </div>
    </div>
  );
}

export default SocialLinks; 